import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Black logo (fixed on top of images, positioned right)
const BLACK_LOGO_URL = "https://customer-assets.emergentagent.com/job_cf82e0fe-468c-4a43-97a9-405e8da70dca/artifacts/7mx81482_260208%20Logo%20Galeries%20Yess4_zw.png";

// Editorial images (in order: 1, 2, 3)
const EDITORIAL_IMAGES = [
    { src: 'https://customer-assets.emergentagent.com/job_charity-fashion-1/artifacts/6776yrur_Slide%201_.png', link: null },
    { src: 'https://customer-assets.emergentagent.com/job_charity-fashion-1/artifacts/nzluumvp_Slide%202_.png', link: '/menu?section=auction-events' },
    { src: 'https://customer-assets.emergentagent.com/job_charity-fashion-1/artifacts/s64lyw00_Slide%203.png', link: '/menu?section=charity' },
];

const HomePage = () => {
    const navigate = useNavigate();

    // Scroll naar top bij laden - fix voor PWA mode
    useEffect(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        
        const timer = setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);
        
        return () => clearTimeout(timer);
    }, []);

    const handleImageClick = (link) => {
        if (link) {
            navigate(link);
        }
    };

    return (
        <div className="min-h-screen bg-white pb-20 relative overflow-x-hidden">
            {/* Fixed Logo Overlay - positioned to the right, full logo visible */}
            <div className="fixed top-0 right-0 z-50 pointer-events-none">
                <div className="pt-2 pr-2 md:pt-4 md:pr-4">
                    <img 
                        src={BLACK_LOGO_URL} 
                        alt="Galeries Yess" 
                        className="w-64 md:w-[22.5rem] lg:w-[26rem] h-auto"
                    />
                </div>
            </div>

            {/* Editorial Images - Full bleed, edge-to-edge, scrollable */}
            <div className="w-full">
                {EDITORIAL_IMAGES.map((image, index) => (
                    <img
                        key={index}
                        src={image.src}
                        alt={`Editorial ${index + 1}`}
                        className={`w-full h-auto block ${image.link ? 'cursor-pointer' : ''}`}
                        data-testid={`editorial-image-${index + 1}`}
                        onClick={() => handleImageClick(image.link)}
                    />
                ))}
            </div>
        </div>
    );
};

export default HomePage;
